var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('editor',{attrs:{"id":_vm.editorId,"api-key":"f9tg25pq47z4zweve160g3wt475r0oycir62ddltkzsd8v6w","init":_vm.initOptions},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }